import { useAtom, useAtomValue } from 'jotai';

import { isMobile } from '@growtherapy/analytics';

import { isScreenShareSupported } from '../../utils';
import { isScreenSharingAtom, isShowingScreenShareConfirmationAtom, participantCountAtom } from '../../video-sdk';
import { ScreenShareControl, ScreenShareMenuItems } from './ScreenShareControl';
import { useSessionModeCallbacks } from './useSessionModeCallbacks';

export function ScreenShareControlWrapper() {
  const inSession = !!useAtomValue(participantCountAtom);
  const isSharing = useAtomValue(isScreenSharingAtom);
  const { switchToMode, stopCurrentMode } = useSessionModeCallbacks();
  const [isShowingScreenShareConfirmation, setIsShowingScreenShareConfirmation] = useAtom(
    isShowingScreenShareConfirmationAtom,
  );

  if (!inSession || isMobile(navigator.userAgent) || !isScreenShareSupported()) {
    return;
  }

  return (
    <ScreenShareControl
      isSharing={isSharing}
      isShowingScreenShareConfirmation={isShowingScreenShareConfirmation}
      onConfirmShare={() => switchToMode('screenshare', { shouldTakeOverScreenShare: true })}
      onHideScreenShareConfirmation={() => setIsShowingScreenShareConfirmation(false)}
      onShare={() => switchToMode('screenshare', { shouldTakeOverScreenShare: false })}
      onStopShare={stopCurrentMode}
    />
  );
}

export function ScreenShareMenuItemsWrapper() {
  const isScreenSharing = useAtomValue(isScreenSharingAtom);
  const { switchToMode, stopCurrentMode: stopSharingScreen } = useSessionModeCallbacks();
  const shareScreen = () => switchToMode('screenshare', { shouldTakeOverScreenShare: false });

  if (!isScreenShareSupported()) return null;

  return <ScreenShareMenuItems isSharing={isScreenSharing} onShare={shareScreen} onStopShare={stopSharingScreen} />;
}
